import { useNavigate } from "react-router-dom";
import { Home, HelpCircle } from "lucide-react";
import { useLanguage } from "@/services/languageService";
import LanguageSwitcher from "./LanguageSwitcher";
import { Button } from "./ui/button";

const Header = () => {
  const navigate = useNavigate();
  const { t, currentLanguage } = useLanguage();
  
  const navigateTo = (path: string) => {
    if (currentLanguage === 'en') {
      navigate(path);
    } else {
      navigate(`/${currentLanguage}${path}`);
    }
  };

  return (
    <header className="w-full bg-white shadow-sm border-b border-gray-200">
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => navigateTo('/')}>
            <img 
              src="/st-pokemon-ball.svg" 
              alt="Pokemon Ball Logo" 
              className="w-8 h-8 sm:w-9 sm:h-9 animate-spin-slow"
              style={{ animationDuration: '8s' }}
            />
            <h1 className="text-xl sm:text-2xl font-bold text-purple-700">
              {t('title')}
            </h1>
          </div>

          <div className="flex items-center gap-3 sm:gap-6">
            <nav className="flex items-center gap-2">
              <Button
                variant="ghost"
                className="flex items-center gap-2"
                onClick={() => navigateTo('/')}
              >
                <Home className="h-4 w-4" />
                <span className="hidden sm:inline">{t('home')}</span>
              </Button>

              <Button
                variant="ghost"
                className="flex items-center gap-2"
                onClick={() => navigateTo('/which-pokemon-am-i')}
              >
                <HelpCircle className="h-4 w-4" />
                <span className="hidden sm:inline">{t('whichPokemonAmI')}</span>
              </Button>
            </nav>
            
            <LanguageSwitcher />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
